const FETCH_CATEGORIES_ASYNC = 'category/FETCH_CATEGORIES_ASYNC';

export const CATEGORY_ACTION_TYPES = {
  FETCH_CATEGORIES_ASYNC,
};
